module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.library.js
// module id = 45
// module chunks = 0